<template lang='pug'>
  .widgets.clearfix
    .widget-wrapper(
      v-for='widget in widgets'
      :id='widget.id'
      :key='widget.id'
      draggable='true'
      @dragstart='drag_start'
      :class='{ "widget-wrapper--hidden": (widget.name === "shares" ? !has_shares : false) }'
    )
      i(:class='[`pbxx-icon`, `pbxx-icon-hc-4x`, `pbxx-icon-${widget.icon ? widget.icon : "widgets"}`]')
      p
        | {{ widget.name | remove_hyphens }}
</template>

<script>
  import { db } from '../utils/firebase'

  export default {
    name: 'widget_selector',
    props: {
      brand_id: {
        type: String,
        required: true
      },
      campaign_id: {
        type: String,
        required: true
      },
      shares: {
        type: Array,
        required: false
      }
    },
    data() {
      return {
        widgets: []
      }
    },
    filters: {
      remove_hyphens(name) {
        return name.replace(/_/g, ' + ')
      }
    },
    firestore() {
      return {
        widgets: db.collection('widgets').where('id', '>', 2),
        
      }
    },
    computed: {
      has_shares() {
        return this.shares && this.shares.length > 0
      }
    },
    methods: {
      drag_start(event) {
        event.dataTransfer.setData('widget_id', event.target.id)
      }
    }
  }
</script>

<style lang='scss' scoped>
  @import 'compass-mixins';
  @import "@promoboxx/pbxx2component/src/styles/variables_and_mixins";
  .widgets {
    padding: 20px 10px;
    .widget-wrapper {
      width: calc(33.3333% - 20px);
      margin: 0 10px 20px;
      float: left;
      border: 1px solid get-color(gray-light);
      padding: 15px 10px;
      text-align: center;
      @include box-shadow(0 1px 2px get-color(gray-light));
      @include border-radius(3px);
      cursor: move;
      i {
        color: get-color(gray-light);
      }
      p {
        margin: 8px 0 4px 0;
        text-transform: capitalize;
      }
      &:hover {
        @include box-shadow(0 1px 6px get-color(gray));
        @include transition(linear all 0.1s);
        opacity: 0.9;
      }
      &--hidden {
        display: none;
      }
    }
  }
</style>
